module.exports = __webpack_public_path__ + "static/media/arizonadiagnosticradiology.c5990c71.jpg";